import {Injectable} from '@angular/core';
import {GlobalConstantsComponent} from '../shared/global-constants/global-constants.component';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProcessSharedService {

  private apiUrl = GlobalConstantsComponent.apiURL;
  private api2Url = GlobalConstantsComponent.api2URL;

  constructor(
    private http: HttpClient,
  ) { }

  /***********************************************************************************************************************
   *                                                APPELS API
   ***********************************************************************************************************************/
  /**
   *  Actualise le process du user.
   *  Renvoi error ou {
   *    status : success,
   *    data : un array avec les différents process states du user
   *    newId: l'id du nouveau state pour le process
   *    next_state: l'objet du state suivant pour le process
   *    hubspot: renvoi null (code commenté)
   *  }
   * @param state - statut du process
   * @param processState - le process
   */
  updateProcessState(state, processState) {
    return this.http.post(`${this.api2Url}user/updateProcessState`, {
      state: state,
      processState: processState,
    });
  }

  updateBookingCareStatus(bookingId,status, datas?){
    return this.http.post(`${this.apiUrl}care/updateBookingCareStatus`, {bookingId : bookingId, status : status, datas: datas}  );
  }

  changeBookingRoom(newRoomId,bookingId) {
    return this.http.get(`${this.apiUrl}care/changeBookingRoom/`+ bookingId + '/' + newRoomId);
  }

  /**
   * Renvoi un array soit vide (pas de propriétés) soit avec des chambres (ES)
   * @param id
   */
  getHouseRooms(id) {
    return this.http.get(`${this.apiUrl}getHouseRooms/`+id) as any;
  }

  /**
   * Renvoi une chambre, si pas trouvée : 404
   * @param id
   */
  getRoom(id) {
    return this.http.get(`${this.apiUrl}user/getAccommodation/`+id) as any;
  }

  getOnGoingBooking(id){
    return this.http.get(`${this.apiUrl}user/getOnGoingBooking/`+id) as any;

  }

  /**
   * Renvoi une liste de chambre selon les ids fournies, si pas trouvée : 404 , si pas de liste : 400
   * @param ids
   */
    getRooms(ids) {
      return this.http.post(`${this.apiUrl}user/getAccommodationsFromList`, {ids} ) as any;
    }

  /**
   * Renvoi un array avec les chambres favorites
   */
  getAccommodationFavorite(id?) {
    return this.http.get(`${this.apiUrl}user/getAccommodationFavorites` + (id ? '/' + id : '')) as any;
  }

  getAgents(){
    return this.http.get(`${this.apiUrl}getAgents`) as any;
  }

  getAdminAgents(){
    return this.http.get(`${this.apiUrl}getAdminAgents`) as any;
  }


  /**
   * Update les dates de début et de fin booking et passe le booking en pending
   * Renvoie : {
   *   status : success || error
   *   data : booking || ''
   * }
   * @param bookingId
   * @param arrivalDate
   * @param departureDate
   */
  updateBookingDates(bookingId,arrivalDate,departureDate) {
    return this.http.post(`${this.apiUrl}housing/updateBookingDates`, {booking_id: bookingId,arrivalDate : arrivalDate,departureDate: departureDate});
  }

  getRoomAmenities(room_id){
    return this.http.post(this.apiUrl + 'getAmenities', {'id': room_id});
  }

  /**
   * SHARED
   */
  getAmenities() {
    return this.http.get(`${this.apiUrl}listAmenities`);
  }

  getFormations(){
    return this.http.get(this.apiUrl + 'getFormations') as any;
  }

  getPropertyPhotos(id){
    return this.http.get(this.apiUrl + 'getPropertyPhotos/' + id);
  }

  getSimilarOffers(datas){
    return this.http.post(`${this.apiUrl}getSimilarOffers`, datas);
  }

  getPageFaq(data) {
    return this.http.get(this.apiUrl + 'getPageFaq/' + data) as any;
  }


  /***********************************************************************************************************************
   *                                                CALCUL/UTILITIES
   ***********************************************************************************************************************/



  //-------------------------------------------------------------------------------------------------------------------------------------



}
